<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h1 class="mb-5">
          {{ $t('Report (constructor)') }}
        </h1>
      </v-col>
    </v-row>
    <v-card
      class="mx-auto pa-5 mb-5"
    >
      <v-card-text>
        <h2 class="mb-5">
          Фильтр
        </h2>
        <v-row class="border_bottom">
          <v-col cols="6" lg="3">
            <v-select
              v-model="selectedPlatform"
              :items="platform"
              label="Платформа"
              item-text="name"
              item-value="id"
              outlined
              prepend-icon="mdi-home"
              hide-details
            />
          </v-col>
          <v-col cols="6" lg="3">
            <v-select
              v-model="selectedClient"
              :items="clientsFilterByPlatform"
              label="Клиент"
              item-text="legal_name"
              item-value="id"
              clearable
              outlined
              prepend-icon="mdi-account-outline"
              hide-details
            />
          </v-col>
          <v-col cols="6" lg="3">
            <v-select
              v-model="selectedSupplier"
              :items="suppliersFilter"
              label="Поставщик"
              item-text="legal_name"
              item-value="id"
              clearable
              outlined
              prepend-icon="mdi-account"
              hide-details
            />
          </v-col>
          <v-col cols="6" lg="3">
            <v-select
              v-model="selectedStatusApplication"
              :items="statusApplication"
              label="Статус"
              item-text="name"
              item-value="code"
              clearable
              outlined
              prepend-icon="mdi-check-network"
              hide-details
              multiple
            />
          </v-col>
        </v-row>
        <v-row>
          <v-btn
            v-if="filtersChanged()"
            class="clear-filters-btn ml-auto"
            @click="clearFilters"
          >
            Очистить фильтры
          </v-btn>
        </v-row>
      </v-card-text>
    </v-card>
    <v-row class="mt-10">
      <v-col cols="6" lg="3">
        <v-select
          v-model="selectedValueTable"
          :items="valueTableItems"
          label="Значение вычисления"
          item-text="label"
          item-value="key"
          outlined
          prepend-icon="mdi-sigma"
          :disabled="isColumnValues"
          hide-details
        />
      </v-col>
      <v-col
        cols="6"
        lg="3"
      >
        <date-range
          :local-storage-prefix="localStoragePrefix"
          @datesChanged="dates = $event"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col v-if="operations.length">
        <pivot
          :data="filteredOperations"
          :fields="fields"
          :row-field-keys="rowFieldKeys"
          :col-field-keys="colFieldKeys"
          :reducer="reducer"
          :is-data-loading="isDataLoading"
          :available-field-keys="availableFieldKeys"
          :default-show-settings="false"
          hide-settings-text="Скрыть конструктор"
          show-settings-text="Показать конструктор таблицы"
          available-fields-label-text="Доступные поля"
          no-data-warning-text="Данные отсуствуют"
          rows-label-text="Строки"
          cols-label-text="Колонки"
          class="pivot"
          :value-columns="valueTableItems"
          @selectedIsColumnValues="isColumnValues = $event"
        >
          <template slot="value" slot-scope="{ value, row, col, isColumnValues }">
            <v-menu
              ref="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <span
                  class="pointer"
                  :style="{color: getThePreferredStatusColor(value)}"
                  v-on="on"
                >
                  {{ reduceValue(value, row, col, isColumnValues) }}
                </span>
              </template>
              <div class="modal-info">
                <template v-if="value && value.length">
                  <div v-for="(item, index) in value" :key="item.id" class="my-5 modal-info__item">
                    <router-link :to="{name: 'Entity', params: {entityName: 'ApplicationHR'}}">
                      ID: {{ item.application && item.application.id }}
                    </router-link>
                    <p :style="{color: getColorByCode(item)}">
                      <span>{{ isColumnValues ? col.label : valueTableItemBySelected && valueTableItemBySelected.label }} :</span>
                      <span>{{ getOnValue(value, row, col, index, item, isColumnValues) }}</span>
                    </p>
                  </div>
                </template>
              </div>
            </v-menu>
          </template>
        </pivot>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-menu
          transition="scale-transition"
          offset-y
          max-width="320px"
        >
          <template v-slot:activator="{ on }">
            <p class="pointer" v-on="on">
              <v-icon>
                mdi-information-variant
              </v-icon>
              Цветовая схема статусов
            </p>
          </template>
          <v-list>
            <v-list-item
              v-for="item in statusApplication"
              :key="item.code"
            >
              <v-list-item-icon>
                <v-icon
                  :color="colorShem[item.code] || '#212121'"
                >
                  mdi-square-rounded
                </v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <div>{{ item.name }}</div>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-btn
        color="success"
        @click="downloadXLSX"
      >
        Отчет в xlsx
        <v-icon
          right
          dark
        >
          mdi-download
        </v-icon>
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import Component from 'vue-class-component';
import GetPlantsHRAndClientListing from '@/graphql/GetPlantsHRAndClientListing.gql';
import {
  Watch, Mixins, Prop,
} from 'vue-property-decorator';
import Pivot from '@/components/common/Pivot/Pivot.vue';
import { getMonthName } from '@/utils/time';
import LoadingDataMixin from '@/mixins/LoadingDataMixin';
import XLSX from 'xlsx';
import DateRange from '@/components/common/DateRange.vue';
import EntityHelperMixin from '@/mixins/EntityHelperMixin';


@Component({
  components: {
    Pivot,
    DateRange,
  },
})
export default class ReportConstructor extends Mixins(LoadingDataMixin, EntityHelperMixin) {
  @Prop({
    type: String,
    required: false,
    default: 'ReportConstructor',
  }) localStoragePrefix;

  fields = [{
    key: 'time_interval',
    getter: (item) => (item.time_interval === 'day' ? 'День' : 'Ночь'),
    label: 'График',
  }, {
    key: 'workType.name',
    getter: (item) => item.workType?.name,
    label: 'Операция',
  }, {
    key: 'application.Supplier.legal_name',
    getter: (item) => item.application?.Supplier?.legal_name,
    label: 'Поставщик',
  }, {
    key: 'application.platform.name',
    getter: (item) => item?.application?.platform?.name,
    label: 'Платформа',
  }, {
    key: 'application.client.legal_name',
    getter: (item) => item.application?.client?.legal_name,
    label: 'Клиент',
  }, {
    key: 'productive_hours',
    getter: (item) => item.workType?.work_billing_type?.name,
    label: 'Производительные/Непроизводительные часы',
  }, {
    key: 'date',
    getter: (item) => item.date.replace(' 00:00:00', ''),
    label: 'Дата',
  }, {
    key: 'month',
    getter: (item) => getMonthName(Number(item.date.split('-')[1])),
    label: 'Месяц',
  }, {
    key: 'category',
    getter: (item) => (item.category ? 'Да' : 'Нет'),
    label: 'Тяжелый товар',
  }, {
    key: 'technology',
    getter: (item) => (item.technology ? 'Да' : 'Нет'),
    label: 'Техника',
  }, {
    key: 'PC',
    getter: (item) => (item.PC ? 'Да' : 'Нет'),
    label: 'ПК',
  }];

  rowFieldKeys = ['application.client.legal_name', 'time_interval', 'application.Supplier.legal_name', 'workType.name'];

  colFieldKeys = ['date'];

  availableFieldKeys = ['productive_hours', 'category', 'technology', 'PC', 'month', 'application.platform.name']

  operations = [];

  platform = [];

  clients = [];

  suppliers = [];

  statusApplication = [];

  selectedPlatform = this.getFromStorage('platform');

  defaultPlatform = null;

  selectedClient = this.getFromStorage('client');

  selectedSupplier = this.getFromStorage('supplier');

  selectedStatusApplication = this.getFromStorage('statusApplication')
    .split(',')
    .filter((status) => status.trim() !== '');

  setInterval = null;

  isDataLoading = false;

  selectedValueTable = this.getFromStorage('valueTable') || 'quantity';

  isColumnValues = false;

  valueTableItems = [
    {
      key: 'quantity',
      label: 'План. количество людей',
    },
    {
      key: 'actual_quantity',
      label: 'Факт. количество людей',
    },
    {
      key: 'custom_quantity',
      label: 'Разность количество людей (факт. - план.) кол.',
      func: (items, row, col, isColumnValues, index) => {
        if (index || index === 0) {
          return items[index].quantity - items[index].actual_quantity;
        }
        const sumQuantity = items.map((i) => i.quantity).reduce((a, b) => a + b);
        const sumActualQuantity = items.map((i) => i.actual_quantity).reduce((a, b) => a + b);
        return sumActualQuantity - sumQuantity;
      },
    },
    {
      key: 'custom_quantity_percent',
      label: 'Процент факт. количество людей от план.',
      func: (items, row, col, isColumnValues, index) => {
        if (index || index === 0) {
          return (items[index].actual_quantity / items[index].quantity).toFixed(2) * 100;
        }
        const sumQuantity = items.map((i) => i.quantity).reduce((a, b) => a + b);
        const sumActualQuantity = items.map((i) => i.actual_quantity).reduce((a, b) => a + b);
        return (sumActualQuantity / sumQuantity).toFixed(2) * 100;
      },
    },
    {
      key: 'size',
      label: 'План. объем',
    },
    {
      key: 'actual_size',
      label: 'Факт. объем',
    },
    {
      key: 'difference_size',
      label: 'Разность объем (факт. - план.) кол.',
      func: (items, row, col, isColumnValues, index) => {
        if (index || index === 0) {
          return items[index].size - items[index].actual_size;
        }
        const sumSize = items.map((i) => i.size).reduce((a, b) => a + b);
        const sumActualSize = items.map((i) => i.actual_size).reduce((a, b) => a + b);
        return sumActualSize - sumSize;
      },
    },
    {
      key: 'difference_size_percent',
      label: 'Процент факт. объема от план.',
      func: (items, row, col, isColumnValues, index) => {
        if (index || index === 0) {
          return (items[index].actual_size / items[index].size).toFixed(2) * 100;
        }
        const sumSize = items.map((i) => i.size).reduce((a, b) => a + b);
        const sumActualSize = items.map((i) => i.actual_size).reduce((a, b) => a + b);
        return (sumActualSize / sumSize).toFixed(2) * 100;
      },
    },
    {
      key: 'actual_work_time',
      label: 'Факт. время работы',
    },
    {
      key: 'performance_watch',
      label: 'Производительные часы',
      func: (items, row, col, isColumnValues, index) => {
        if (index || index === 0) {
          return (items[index]?.workType?.work_billing_type?.code === 'productive' && items[index].actual_work_time) || 0;
        }
        return items.map((i) => (i?.workType?.work_billing_type?.code === 'productive' && i.actual_work_time) || 0).reduce((a, b) => a + b) || '';
      },
    },
    {
      key: 'unproductive_hours',
      label: 'Непроизводительные часы',
      func: (items, row, col, isColumnValues, index) => {
        if (index || index === 0) {
          return (items[index]?.workType?.work_billing_type?.code === 'unproductive' && items[index].actual_work_time) || 0;
        }
        return items.map((i) => (i.workType?.work_billing_type?.code === 'unproductive' && i.actual_work_time) || 0).reduce((a, b) => a + b) || '';
      },
    }, {
      key: 'performance',
      label: 'Производительность',
      func: (items, row, col, isColumnValues, index) => {
        if (index || index === 0) {
          return items[index].performance;
        }
        return (items.map((i) => i.performance).reduce((a, b) => a + b) / items.length).toFixed(2);
      },
    }, {
      key: 'quality',
      label: 'Качество',
      func: (items, row, col, isColumnValues, index) => {
        if (index || index === 0) {
          return items[index].quality;
        }
        return (items.map((i) => i.quality).reduce((a, b) => a + b) / items.length).toFixed(2);
      },
    },
  ];

  colorShem = {
    HR_rework: '#b51113',
    supplier_confirmation: '#00b7ff',
    supplier_confirmed_fact: '#2a4bd2',
    coordinator_confirmation: '#2f4654',
    HR_approve: '#fff200',
    in_progress: '#5cd026',
    actual_data_filled: '#0a5d0e',
    created: '#cbdc91',
    coordinator_cancelled: '#c49cba',
    supplier_cancelled: '#c49cba',
    HR_cancelled: '#c49cba',
    HR_reassigned: '#e86738',
    formation_sheet_started: '#8320a2',
  }

  dates = ['2020-11-10', '2020-11-27']

  defaultDates = []

  async mounted() {
    this.calculateDefaultDates();
  }

  calculateDefaultDates() {
    const dateNow = new Date();
    const dateAgo = new Date();
    dateAgo.setMonth(dateAgo.getMonth() - 1);
    dateAgo.setDate(1);
    this.defaultDates = [dateAgo.toISOString().split('T')[0], dateNow.toISOString().split('T')[0]];
  }

  get clientsFilterByPlatform() {
    if (this.selectedPlatform && Number(this.selectedPlatform)) {
      return this.clients.filter((i) => i.Plants && i.Plants.some((ele) => Number(ele.id) === Number(this.selectedPlatform)));
    }
    return this.clients;
  }

  get suppliersFilter() {
    if (this.selectedPlatform && Number(this.selectedPlatform)) {
      return this.suppliers.filter((i) => i.PlantsHR && i.PlantsHR.some((ele) => Number(ele.id) === Number(this.selectedPlatform)));
    }
    return this.suppliers;
  }

  get reducer() {
    return (sum, item) => {
      if (sum) {
        sum.push(item);
      } else {
        sum = [item];
      }
      return sum;
    };
  }

  get filteredOperations() {
    let filteredOperations = this.operations;
    if (this.selectedClient) {
      filteredOperations = filteredOperations.filter((i) => i.application?.client?.id === this.selectedClient);
    }
    if (this.selectedSupplier) {
      filteredOperations = filteredOperations.filter((i) => i.application?.Supplier?.id === this.selectedSupplier);
    }
    if (this.selectedStatusApplication.length) {
      filteredOperations = filteredOperations.filter((i) => this.selectedStatusApplication.some((status) => status === i.application?.status?.code));
    }
    return filteredOperations;
  }

  get valueTableItemBySelected() {
    return this.valueTableItems.find((i) => i.key === this.selectedValueTable);
  }

  getThePreferredStatusColor(items) {
    let color = '';
    if (items && items.length) {
      Object.keys(this.colorShem).forEach((key) => {
        if (items.some((e) => e.application?.status?.code === key)) {
          if (!color) {
            color = this.colorShem[key];
          }
        }
      });
    }
    return color || '#212121';
  }

  getOnValue(value, row, col, index, item, isColumnValues) {
    if (isColumnValues) {
      const valueTableItem = this.valueTableItems.find((i) => i.key === col.key);
      if (valueTableItem && valueTableItem.func) {
        return valueTableItem.func(value, row, col, isColumnValues, index);
      }
      return item[col.key];
    }
    if (this.valueTableItemBySelected && this.valueTableItemBySelected.func) {
      return this.valueTableItemBySelected.func(value, row, col, isColumnValues, index);
    }
    return item[this.selectedValueTable];
  }

  getColorByCode(item) {
    if (item.application?.status?.code && this.colorShem[item.application.status.code]) {
      return this.colorShem[item.application.status.code];
    }
    return '#212121';
  }

  reduceValue(items, row, col, isColumnValues) {
    if (!items) {
      return '';
    }
    if (isColumnValues) {
      const valueTableItem = this.valueTableItems.find((i) => i.key === col.key);
      if (valueTableItem && valueTableItem.func) {
        return valueTableItem.func(items, row, col, isColumnValues);
      }
    } else if (this.valueTableItemBySelected?.func && typeof this.valueTableItemBySelected.func === 'function') {
      return this.valueTableItemBySelected.func(items, row, col);
    }

    const array = items.filter((a) => (isColumnValues ? Number(a[col.key]) : Number(a[this.selectedValueTable])));
    if (array && array.length) {
      return array.map((i) => (isColumnValues ? i[col.key] : i[this.selectedValueTable])).reduce((a, b) => a + b);
    }
    return '';
  }

  downloadXLSX() {
    const elt = document.getElementById('pivot-table');
    const wb = XLSX.utils.table_to_book(elt);
    let fileName = `report-${this.dates.join('-')}`;
    if (this.selectedPlatform) {
      fileName += `-platform_${this.platform.find((i) => i.id === this.selectedPlatform)?.name || ''}`;
    }
    if (this.selectedClient) {
      fileName += `-client_${this.clientsFilterByPlatform.find((i) => i.id === this.selectedClient)?.legal_name || ''}`;
    }
    if (this.selectedSupplier) {
      fileName += `-provider_${this.suppliersFilter.find((i) => i.id === this.selectedSupplier)?.legal_name || ''}`;
    }
    if (this.selectedStatusApplication.length) {
      const selectedStatus = this.selectedStatusApplication.map((status) => this.statusApplication.find((i) => i.code === status)?.name);
      fileName += `-status_${selectedStatus.join('-') || ''}`;
    }
    return XLSX.writeFile(wb, `${fileName}.xlsx`);
  }

  async loadOperations() {
    this.isDataLoading = true;
    if (!this.selectedPlatform) {
      this.selectedPlatform = this.defaultPlatform;
    }
    const filterApplications = {
      $and: [
        {
          platform__id: {
            $like: this.selectedPlatform,
          },
        },
      ],
    };
    const applicationsIds = await this.loadApplicationsIdsByFilter(filterApplications);
    const filterApplicationsIds = [];
    applicationsIds.forEach((id) => {
      filterApplicationsIds.push({
        application__id: {
          $like: id,
        },
      });
    });
    const filter = {
      $and: [
        {
          date: {
            $gte: this.dates[0],
          },
        },
        {
          date: {
            $lte: this.dates[1],
          },
        },
        {
          $or: filterApplicationsIds,
        },
      ],
    };
    try {
      const operations = await this.loadEntityListing('Operation', { filter: JSON.stringify(filter) }, 'network-only');
      if (operations?.length) {
        this.operations = operations;
      } else {
        this.operations = [];
      }
      this.isDataLoading = false;
    } catch (e) {
      console.error(e);
      this.isDataLoading = false;
    }
  }

  loadPlatformAndClients() {
    return this.$apollo.query({
      query: GetPlantsHRAndClientListing,
      variables: {},
    }).then((res) => {
      if (res?.data?.getPlantsHRListing?.edges?.length) {
        this.platform = res?.data?.getPlantsHRListing?.edges.map((item) => item.node);
        this.defaultPlatform = this.platform[0]?.id;
      }
      if (res?.data?.getClientListing?.edges?.length) {
        this.clients = res?.data?.getClientListing?.edges.map((item) => item.node);
      }
      if (res?.data?.getSupplierListing?.edges?.length) {
        this.suppliers = res?.data?.getSupplierListing?.edges.map((item) => item.node);
      }
      if (res?.data?.getStatusApplicationListing?.edges?.length) {
        this.statusApplication = res?.data?.getStatusApplicationListing?.edges.map((item) => item.node);
      }
      return res;
    }).catch((e) => {
      console.error(e);
    });
  }

  async beforeMount() {
    await this.loadPlatformAndClients();
    if (this.dates.length === 2) {
      await this.loadOperations();
    }
    this.setInterval = setInterval(this.loadOperations, 1000 * 60 * 5);
  }

  beforeDestroy() {
    clearInterval(this.setInterval);
  }

  @Watch('selectedPlatform')
  selectedPlatformChanged(value) {
    this.selectedClient = null;
    this.selectedSupplier = null;
    if (typeof window !== 'undefined' && localStorage) {
      this.setToStorage('platform', value);
      this.setToStorage('client', '');
      this.setToStorage('supplier', '');
    }
    this.loadOperations();
  }

  @Watch('selectedClient')
  selectedClientChanged(value) {
    if (typeof window !== 'undefined' && localStorage) {
      this.setToStorage('client', value);
    }
  }

  @Watch('selectedSupplier')
  selectedSupplierChanged(value) {
    if (typeof window !== 'undefined' && localStorage) {
      this.setToStorage('supplier', value);
    }
  }

  @Watch('selectedStatusApplication')
  selectedStatusApplicationChanged(value) {
    if (typeof window !== 'undefined' && localStorage) {
      this.setToStorage('statusApplication', value.join(','));
    }
  }

  @Watch('dates')
  datesChanged() {
    this.loadOperations();
  }

  @Watch('selectedValueTable')
  selectedValueTableChanged(value) {
    if (typeof window !== 'undefined' && localStorage) {
      this.setToStorage('valueTable', value);
    }
  }

  filtersChanged() {
    return this.selectedPlatform !== this.defaultPlatform
      || this.selectedSupplier
      || this.selectedClient
      || this.selectedStatusApplication.length > 0
      || this.selectedValueTable !== 'quantity'
      || this.dates.length !== 2
      || this.dates[0] !== this.defaultDates[0]
      || this.dates[1] !== this.defaultDates[1];
  }

  clearFilters() {
    this.selectedStatusApplication = [];
    this.selectedValueTable = 'quantity';
    if (this.selectedPlatform === this.defaultPlatform) {
      this.selectedPlatformChanged(this.selectedPlatform);
    } else {
      this.selectedPlatform = this.defaultPlatform;
    }
    this.$bus.$emit('clear-filters');
  }
}
</script>

<style scoped>
  .pivot /deep/ table th{
    border: 1px solid #9e9e9e;
    padding: 5px;
  }
  .pivot /deep/ table td{
    border: 1px solid #9e9e9e;
    padding: 5px;
  }
  .pivot /deep/ .alert-warning{
    text-align: center;
    font-size: 18px;
    color: brown;
  }
  .pivot /deep/ .table-responsive{
    overflow-y: auto;
  }
  .pointer {
    cursor: pointer;
  }
  .modal-info {
    background-color: #fff;
    border-radius: 10px;
    padding: 10px;
  }
  .modal-info__item {
    border-bottom: 1px solid #9e9e9e;
  }
  .modal-info__item:last-child {
    border-bottom: none;
  }
</style>
